console.log("加载main.js");
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import store from "./store";
import "@/utils/request";
import "@/Model/map.js";

//商砼专用

import ElementUI from "element-ui";
// import 'element-ui/lib/theme-chalk/index.css';    /*默认主题*/
import $ from "jquery"; //引入Jquery模块
import ApplicationMgr from "./router/ApplicationMgr"; //增加全局方法引用 用于初始化系统信息 add by chenk 2019.01.03
import { Loading } from "element-ui";
import echarts from "echarts";
import "@/STERP";
import EventEmitter from "@/utils/EventEmitter";
import md5 from 'js-md5';

import { readyGo } from "@/utils";


// 2. 先执行 Vue.use(ElementUI)（让 Element 挂载原生 $message）
Vue.use(ElementUI, { size: "small" });

// 3. 引入 NoticeMessagePlugin（插件形式）
import NoticeMessagePlugin from "@/utils/notice";
// 4. 执行 Vue.use(NoticeMessagePlugin)（此时 Element 已初始化，挂载 $message）
Vue.use(NoticeMessagePlugin);

Vue.prototype.$readyGo = readyGo;
Vue.prototype.$md5 = md5;
// Vue.use(VueGridLayout)
Vue.prototype.$echarts = echarts;
Vue.directive('resize', {
    bind(el, binding) {
        // el为绑定的元素，binding为绑定给指令的对象
        // console.log(el, "绑定", binding);
        let width = "",
            height = "";
        function isReize() {
            const style = document.defaultView.getComputedStyle(el);
            if (width !== style.width || height !== style.height) {
                binding.value({ width: style.width, height: style.height }); // 关键(这传入的是函数,所以执行此函数)
            }
            width = style.width;
            height = style.height;
        }
        el.__vueSetInterval__ = setInterval(isReize, 300);
    },
    unbind(el) {
        // console.log(el, "解绑");
        clearInterval(el.__vueSetInterval__);
    },
}
)
Vue.directive('angle', {
    inserted: function (el, binding, vnode) {
        // el.children[0].value = binding.value
        let angleValue = el.children[0]
        // console.log(vnode)
        // // vnode.data.model.callback(angleValue.value)
        // console.log(angleValue.value)inputkeyup
        // console.log(angleValue);
        angleValue.addEventListener('blur', function (e) {
            let str = angleValue.value
            str = str.replace(/'/g, '')
            angleValue.value = str
        })
        el.addEventListener('keyup', function (e) {
            e = e || window.event
            let str = angleValue.value
            let tmp = ''
            // str = str.replace(/：/g, ':')
            // str = str.replace(/。/g, '.')
            // str = str.replace(/“/g, '"')
            // str = str.replace(/”/g, '"')
            // str = str.replace(/【/g, '[')
            // str = str.replace(/】/g, ']')
            // str = str.replace(/《/g, '<')
            // str = str.replace(/》/g, '>')
            // str = str.replace(/，/g, ',')
            // str = str.replace(/？/g, '?')
            // str = str.replace(/、/g, ',')
            // str = str.replace(/；/g, ';')
            // str = str.replace(/（/g, '(')
            // str = str.replace(/）/g, ')')
            // str = str.replace(/‘/g, "'")
            // str = str.replace(/’/g, "'")
            // str = str.replace(/『/g, '[')
            // str = str.replace(/』/g, ']')
            // str = str.replace(/「/g, '[')
            // str = str.replace(/」/g, ']')
            // str = str.replace(/﹃/g, '[')
            // str = str.replace(/﹄/g, ']')
            // str = str.replace(/〔/g, '{')
            // str = str.replace(/〕/g, '}')
            // str = str.replace(/—/g, '-')
            // str = str.replace(/·/g, '.')
            // console.log(e.key);
            if (e.key == "'" || e.key == "v" || e.key == "Control") {
                str = str.replace(/'/g, '')
            }
            str = str.replace(/,/g, '')
            str = str.replace(/，/g, '')
            str = str.replace(/[\\ /=]/g, "");
            /* 正则转换全角为半角 */
            for (var i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) === 12288) {
                    tmp += String.fromCharCode(str.charCodeAt(i) - 12256)
                    continue
                }
                if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
                    tmp += String.fromCharCode(str.charCodeAt(i) - 65248)
                } else {
                    tmp += String.fromCharCode(str.charCodeAt(i))
                }
            }
            // console.log(angleValue.value)
            // console.log(binding)
            // console.log(vnode)
            // tmp = tmp.replace(/[`~!@#$%^&*@#￥%……&*]/g, '')
            // vnode.data.model.callback(tmp)
            angleValue.value = tmp
        })
    }
})

Vue.directive('angle2', {
    inserted: function (el, binding, vnode) {
        let angleValue = el.children[0].children[0]
        angleValue.addEventListener('blur', function (e) {
            let str = angleValue.value
            str = str.replace(/'/g, '')
            angleValue.value = str
        })
        el.addEventListener('keyup', function (e) {
            e = e || window.event
            let str = angleValue.value
            let tmp = ''
            if (e.key == "'" || e.key == "v" || e.key == "Control") {
                str = str.replace(/'/g, '')
            }
            str = str.replace(/,/g, '')
            str = str.replace(/，/g, '')
            str = str.replace(/[\\ /=]/g, "");
            /* 正则转换全角为半角 */
            for (var i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) === 12288) {
                    tmp += String.fromCharCode(str.charCodeAt(i) - 12256)
                    continue
                }
                if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
                    tmp += String.fromCharCode(str.charCodeAt(i) - 65248)
                } else {
                    tmp += String.fromCharCode(str.charCodeAt(i))
                }
            }
            angleValue.value = tmp
            // vnode.data.model.callback(tmp)
        })
    }
})

Vue.prototype.$axios = axios;
window.$Loading = Loading;

window.EventBus = new EventEmitter();

//#endregion axios
/**
 * 初始化Vue页面
 */
function fInitVue(a) {
    // console.log(router);
    //使用钩子函数对路由进行权限跳转
    /*! ! ! ! 由于现在没有登录页面的验证，是直接进入主页面所以注释下面验证方法--路由的导航守卫 ! ! ! ! */
    router.beforeEach((to, from, next) => {
        const roles = localStorage.getItem("loginKey");
        if (to.path == "/StirPage" || to.path == "/FrontServiceConfig" || to.path == "/FrontServiceMgr" || to.path == "/LED" || to.path == "/ShowClientWeb" || to.path == "/LookEvidence" || to.path == "/repair" || to.path == "/carInfo") {
            next();
            return;
        }
        if (to.path.indexOf("Notice") !== -1) {
            next();
            return;
        }
        if (
            to.path == "/login" &&
            StarSoft.isLogin &&
            localStorage.getItem("autoChecked") == "true"
        ) {
            next("/");
        }
        if (to.path == "/login") {
            console.log("进入登录界面", from, to);
            next();
            return;
        }
        // const isInitSys = StarSoft.isInitSys;//localStorage.getItem(StarSoft.Enum.isInitSys);
        // if (!isInitSys) {
        //     ApplicationMgr.InitSys(fCallBack);
        //     return;
        // }
        fCallBack(null);
        function fCallBack(initData) {
            const role = StarSoft.LoginKey; // localStorage.getItem('loginKey');
            if (from.path == "/login") {
                console.log("这是登录页面，进入其他页面", from, to);
            }
            if (!role && to.path !== "/login" && !StarSoft.U_SID && to.path !== "/FrontServiceConfig" && to.path !== "/FrontServiceMgr" && to.path !== "/LED" && to.path !== "/ShowClientWeb" && to.path !== "/LookEvidence" && to.path !== "/repair" && to.path !== "/carInfo") {
                console.log("会话超时或不存在，进入登录界面");
                if (StarSoft.ShowLeftRightID) {
                    StarSoft.U_SID = "default";
                    next("/timeOut");
                    return;
                }
                next("/login");
            }
            // else if(to.meta.permission){
            //     // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
            //     role === 'admin' ? next() : next('/403');
            // }
            else {
                localStorage.setItem("loginKey", StarSoft.LoginKey);
                // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
                if (
                    navigator.userAgent.indexOf("MSIE") > -1 &&
                    to.path === "/editor"
                ) {
                    Vue.prototype.$alert(
                        "vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看",
                        "浏览器不兼容通知",
                        {
                            confirmButtonText: "确定"
                        }
                    );
                } else {
                    console.log("路由守卫", from, to);
                    //只有iframe页面才进行OPOA页面加载
                    if (to.meta.isIframe) {
                        console.log('object', to);
                        // ApplicationMgr.fInitOPOAPage();
                        if (to.meta.IsNotifyClient == 203) {
                            if (to.meta.alwaysSrc) {
                                to.meta.src = `${to.meta.alwaysSrc
                                    }?onepage=true&LoginUserID=${StarSoft.InitInfo.LoginInfo.UserID
                                    }&LoginKey=${StarSoft.V8LoginKey}`;
                            } else {
                                to.meta.alwaysSrc = to.meta.src;
                                to.meta.src += `?onepage=true&LoginUserID=${StarSoft.InitInfo.LoginInfo.UserID
                                    }&LoginKey=${StarSoft.V8LoginKey}`;
                            }
                            if (to.name == 'ZNPS_ZNJK_CLJK_93020100' && to.params.objectID) {
                                to.meta.src += `&objectType=${to.params.objectType}&objectID=${to.params.objectID}`
                            }
                            if (to.name == 'ZNPS_ZNJK_DISPCAR_93020500' && to.params.soid) {
                                to.meta.src += `&soid=${to.params.soid}`
                            }

                            if (to.meta.src.includes("target")) {
                                window.open(to.meta.src);
                                return;
                            }
                        }
                    }
                    if (!StarSoft.isInitUI) {
                        StarSoft.isInitUI = true;
                        if (to.path == "/emptyPage") {
                            next(ApplicationMgr.GetIndexRoute());
                            return;
                        }
                        if (localStorage.getItem("changeCompany")) {
                            let routePath = ApplicationMgr.GetIndexRoute();
                            if (routePath) {
                                localStorage.removeItem("changeCompany");
                                next(routePath);
                                return;
                            }
                        }
                    }
                    const URLdata = getSearchParams(window.location.hash);
                    if (URLdata.url) {
                        next(URLdata.url);
                    } else {
                        next();
                    }
                }
            }
        }
    });

    if (!StarSoft.isInitSys && !StarSoft.U_SID) {
        if (
            location.hash !== "#/StirPage" &&
            location.hash.indexOf("Notice") === -1 && location.hash != "#/FrontServiceConfig" && location.hash != "#/FrontServiceMgr" && location.hash.indexOf('#/LED') === -1 && location.hash.indexOf('#/ShowClientWeb') === -1 && location.hash.indexOf('#/LookEvidence') === -1 && location.hash.indexOf('#/carInfo') === -1 && location.hash.indexOf('#/repair') === -1
        ) {
            location.hash = "/login";
        }
    }
    // else{
    //     if(lastPage&&StarSoft.noAlertPage.indexOf(lastPage)==-1){
    //         console.info("直接进入上次页面",lastPage);
    //         localStorage.setItem(StarSoft.Keys.lastPage,"");
    //         location.hash=lastPage;
    //     }

    // }

    StarSoft.vuePage = new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount("#app");

    $(function () {
        $("#loading").hide();
    });
}

//#region 增加初始页面的锚点 add by chenk 2019.06.13
//取消登录返回上次页面 modify by chenk 2019.07.05
// var hashUrl=location.hash;
// console.info("当前锚点",hashUrl);
// var lastPage=localStorage.getItem(StarSoft.Keys.lastPage);
// if(lastPage&&(StarSoft.noAlertPage.indexOf(lastPage)!=-1||lastPage.indexOf("KanbanSet_4005?onepage=true")!=-1)){
//     lastPage="";
//     localStorage.setItem(StarSoft.Keys.lastPage,"");
// }
// console.info("上次锚点",lastPage);
// if(!lastPage&&StarSoft.noAlertPage.indexOf(hashUrl)==-1){
//     localStorage.setItem(StarSoft.Keys.lastPage,hashUrl);
// }
//#endregion 增加初始页面的锚点 add by chenk 2019.06.13
function fInitLoadJs() {
    try {
        if (!loadJs) {
            setTimeout(() => {
                fInitLoadJs();
            }, 50);
            return;
        }
    } catch (e) {
        setTimeout(() => {
            fInitLoadJs();
        }, 50);
        return;
    }
    loadJs.Data(function () {
        ApplicationMgr.InitSys(fInitVue);
    });
}


// 获取url参数  #abc?a=1&b=2  返回 参数对象 {a:1,b:2}
const getSearchParams = searchURL => {
    if (!searchURL) return {};
    const paramsURL = searchURL.split("?")[1];
    if (!paramsURL) return {};
    const paramsArr = paramsURL.split("&");
    const outObj = {};
    for (let index = 0; index < paramsArr.length; index++) {
        const element = paramsArr[index].split("=");
        outObj[element[0]] = element[1];
    }
    return outObj;
};
if (window.location.hash.includes("LoginKey")) {
    const URLdata = getSearchParams(window.location.hash);
    StarSoft.LoginKey = URLdata.LoginKey;
    StarSoft.LoginUserID = URLdata.LoginUserID;
    StarSoft.ShowLeftRightID
}
fInitLoadJs();

